import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loader-service',
  templateUrl: './loader-service.component.html',
  styleUrls: ['./loader-service.component.scss']
})
export class LoaderServiceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/loader-service/loader-service.component.ts